module.exports = {
  "country": "NO",
  "artist": "Bobbysocks!",
  "song": "La det swinge",
  "year": "1985",
  "place": "1",
  "spotify": "1D5JiCspnkQx8L57R3qpAb"
};